(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oishii-catalogue"]) return;
  try {
    
  if (!customElements.get('oishii-catalogue')) {
    customElements.define('oishii-catalogue', class extends HTMLElement {
      connectedCallback() {
        if (this.active) return;
        this.active = true;
        this.events = new AbortController();
        const { signal } = this.events;
        if (!this.initialized) {
          this.initialized = true;
          this.labels = JSON.parse(this.querySelector('[data-oo-catalogue-labels]').textContent);
          this.products = [];
          this.options = { series: [], type: [], character: [] };
          this.state = this.readState();
          this.pageSize = 24;
          this.collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric: true, sensitivity: 'base' });
        }
        this.querySelectorAll('[data-oo-enhance]').forEach(element => { element.hidden = false; });
        this.addEventListener('change', event => this.onChange(event), { signal });
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.addEventListener('input', event => this.onInput(event), { signal });
        this.querySelector('[data-oo-search-form]').addEventListener('submit', event => { event.preventDefault(); this.applySearch(); }, { signal });
        window.addEventListener('popstate', () => { this.state = this.readState(); if (this.ready) this.render(); }, { signal });
        this.querySelector('[data-oo-filter-dialog]').addEventListener('close', () => this.restoreFacets(), { signal });
        this.media = window.matchMedia('(min-width: 850px)');
        this.media.addEventListener('change', () => { if (this.media.matches) this.querySelector('[data-oo-filter-dialog]').close(); }, { signal });
        if (this.ready) this.render();
        else this.load();
      }
      disconnectedCallback() {
        this.active = false;
        this.events?.abort();
        this.fetchController?.abort();
        clearTimeout(this.searchTimer);
      }
      text(key, values = {}) {
        return Object.entries(values).reduce((output, [name, value]) => output.split(`{${name}}`).join(String(value)), this.labels[key] || key);
      }
      readState() {
        const params = new URLSearchParams(window.location.search);
        const sort = params.get('oo_sort');
        return {
          series: new Set(params.getAll('oo_series')),
          type: new Set(params.getAll('oo_type')),
          character: new Set(params.getAll('oo_character')),
          query: params.get('oo_q') || '',
          sort: ['az', 'za', 'price_asc', 'price_desc'].includes(sort) ? sort : 'az',
          page: Math.max(1, Number.parseInt(params.get('oo_page') || params.get('page') || '1', 10) || 1)
        };
      }
      writeState() {
        const url = new URL(window.location.href);
        for (const key of ['oo_series', 'oo_type', 'oo_character', 'oo_q', 'oo_sort', 'oo_page', 'page', 'sort_by']) url.searchParams.delete(key);
        for (const facet of ['series', 'type', 'character']) [...this.state[facet]].sort(this.collator.compare).forEach(value => url.searchParams.append(`oo_${facet}`, value));
        if (this.state.query) url.searchParams.set('oo_q', this.state.query);
        if (this.state.sort !== 'az') url.searchParams.set('oo_sort', this.state.sort);
        if (this.state.page > 1) url.searchParams.set('oo_page', this.state.page);
        if (url.href !== window.location.href) window.history.pushState({}, '', url);
      }
      async fetchPage(page, signal) {
        const url = new URL(this.dataset.collectionUrl, window.location.origin);
        url.searchParams.set('section_id', 'oishii-catalogue-feed');
        url.searchParams.set('page', String(page));
        url.searchParams.set('sort_by', 'title-ascending');
        const current = new URLSearchParams(window.location.search);
        for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.has(key)) url.searchParams.set(key, current.get(key));
        if (this.dataset.previewThemeId) {
          url.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
          url.searchParams.set('_oo_preview_refresh', this.previewLoadNonce);
        }
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
        if (!response.ok) throw new Error(`Catalogue request failed (${response.status}, page ${page})`);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = parsed.querySelector('[data-oo-catalogue-feed]');
        if (!feed || Number(feed.dataset.page) !== page) throw new Error(`Catalogue page missing (requested ${page}, received ${feed?.dataset.page || 'none'})`);
        return feed;
      }
      async load() {
        this.fetchController?.abort();
        const controller = new AbortController();
        this.fetchController = controller;
        this.previewLoadNonce = this.dataset.previewThemeId ? Date.now().toString() : '';
        const timeout = setTimeout(() => controller.abort(), 60000);
        this.querySelector('[data-oo-status]').textContent = this.text('loading');
        this.querySelector('[data-oo-retry]').hidden = true;
        try {
          const first = await this.fetchPage(1, controller.signal);
          const feeds = [first];
          const pages = Number(first.dataset.pages);
          let next = 2;
          await Promise.all(Array.from({ length: Math.min(3, Math.max(0, pages - 1)) }, async () => {
            while (next <= pages) { const page = next++; feeds.push(await this.fetchPage(page, controller.signal)); }
          }));
          if (!this.isConnected || controller !== this.fetchController) return;
          const seen = new Set();
          this.products = feeds.flatMap(feed => [...feed.querySelectorAll('template[data-oo-product]')]).filter(template => {
            if (seen.has(template.dataset.id)) return false;
            seen.add(template.dataset.id);
            return true;
          }).map(template => {
            const tags = JSON.parse(template.dataset.tags);
            const values = prefix => tags.filter(tag => tag.startsWith(prefix)).map(tag => tag.slice(prefix.length).trim()).filter(Boolean);
            return {
              id: template.dataset.id,
              title: template.dataset.title,
              price: Number(template.dataset.price),
              series: values('Series:'),
              type: values('Type:'),
              character: values('Character:'),
              category: values('Category:')[0] || this.text('other'),
              search: `${template.dataset.title} ${tags.join(' ')}`.normalize('NFKC').toLocaleLowerCase(),
              template
            };
          });
          if (this.products.length !== Number(first.dataset.total)) throw new Error(`Incomplete catalogue (${this.products.length}/${first.dataset.total}, ${feeds.length}/${pages} pages)`);
          this.buildFacets();
          this.ready = true;
          this.dataset.ready = 'true';
          this.querySelectorAll('[data-oo-search], [data-oo-search-form] button, [data-oo-sort], [data-oo-open-filters], [data-oo-character-search], [data-oo-clear]').forEach(control => { control.disabled = false; });
          this.querySelector('[data-oo-fallback-pagination]').hidden = true;
          this.querySelector('[data-oo-status]').textContent = '';
          delete this.dataset.loadError;
          this.render();
        } catch (error) {
          if (!this.isConnected || controller !== this.fetchController) return;
          this.dataset.loadError = String(error.message || error.name || 'Unknown catalogue error');
          this.querySelector('[data-oo-status]').textContent = this.text('error');
          this.querySelector('[data-oo-retry]').hidden = false;
        } finally { clearTimeout(timeout); }
      }
      makeOption(facet, value) {
        const label = document.createElement('label');
        label.className = 'oo-catalogue__option';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.dataset.facet = facet;
        input.value = value;
        const name = document.createElement('span');
        name.textContent = value;
        const count = document.createElement('span');
        count.className = 'oo-catalogue__option-count';
        count.setAttribute('aria-hidden', 'true');
        label.append(input, name, count);
        this.options[facet].push({ value, input, count, label });
        return label;
      }
      buildFacets() {
        this.options = { series: [], type: [], character: [] };
        const values = facet => [...new Set(this.products.flatMap(product => product[facet]))].sort(this.collator.compare);
        for (const facet of ['series', 'character']) {
          const container = this.querySelector(`[data-oo-options="${facet}"]`);
          const fragment = document.createDocumentFragment();
          let previousLetter = '';
          for (const value of values(facet)) {
            const letter = value[0].toLocaleUpperCase();
            if (facet === 'character' && letter !== previousLetter) {
              const heading = document.createElement('p');
              heading.className = 'oo-catalogue__character-letter';
              heading.dataset.letter = letter;
              heading.textContent = letter;
              fragment.append(heading);
              previousLetter = letter;
            }
            fragment.append(this.makeOption(facet, value));
          }
          container.replaceChildren(fragment);
        }
        const groups = new Map();
        this.products.forEach(product => {
          if (!groups.has(product.category)) groups.set(product.category, new Set());
          product.type.forEach(type => groups.get(product.category).add(type));
        });
        this.parentOptions = [];
        const fragment = document.createDocumentFragment();
        for (const [category, types] of [...groups].sort((a, b) => this.collator.compare(a[0], b[0]))) {
          if (!types.size) continue;
          const group = document.createElement('details');
          group.className = 'oo-catalogue__type-group';
          group.open = [...types].some(type => this.state.type.has(type));
          const heading = document.createElement('summary');
          heading.textContent = category;
          const body = document.createElement('div');
          body.className = 'oo-catalogue__type-options';
          const parent = document.createElement('label');
          parent.className = 'oo-catalogue__option oo-catalogue__parent-option';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.dataset.typeParent = category;
          const name = document.createElement('span');
          name.textContent = category;
          const count = document.createElement('span');
          count.className = 'oo-catalogue__option-count';
          count.setAttribute('aria-hidden', 'true');
          parent.append(input, name, count);
          body.append(parent);
          [...types].sort(this.collator.compare).forEach(type => body.append(this.makeOption('type', type)));
          group.append(heading, body);
          fragment.append(group);
          this.parentOptions.push({ input, count, types, group });
        }
        this.querySelector('[data-oo-options="type"]').replaceChildren(fragment);
      }
      matches(product, excludedFacet = '') {
        const terms = this.state.query.normalize('NFKC').toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        if (!terms.every(term => product.search.includes(term))) return false;
        return ['series', 'type', 'character'].every(facet => facet === excludedFacet || this.state[facet].size === 0 || product[facet].some(value => this.state[facet].has(value)));
      }
      render() {
        if (!this.ready || !this.isConnected) return;
        const matches = this.products.filter(product => this.matches(product));
        matches.sort((a, b) => {
          if (this.state.sort === 'price_asc') return a.price - b.price || this.collator.compare(a.title, b.title);
          if (this.state.sort === 'price_desc') return b.price - a.price || this.collator.compare(a.title, b.title);
          return this.collator.compare(a.title, b.title) * (this.state.sort === 'za' ? -1 : 1);
        });
        const pageCount = Math.max(1, Math.ceil(matches.length / this.pageSize));
        this.state.page = Math.min(pageCount, Math.max(1, this.state.page));
        const start = (this.state.page - 1) * this.pageSize;
        const fragment = document.createDocumentFragment();
        for (const product of matches.slice(start, start + this.pageSize)) {
          const card = document.importNode(product.template.content, true);
          card.querySelector('[data-product-key]').classList.add('oo-catalogue__item');
          card.querySelectorAll('product-form-component').forEach(form => { form.dataset.sectionId = this.dataset.sectionId; });
          fragment.append(card);
        }
        this.querySelector('[data-oo-grid]').replaceChildren(fragment);
        this.querySelector('[data-oo-empty]').hidden = matches.length !== 0;
        this.querySelector('[data-oo-result-count]').textContent = this.text('showing', { start: matches.length ? start + 1 : 0, end: Math.min(start + this.pageSize, matches.length), count: matches.length });
        this.querySelector('[data-oo-page-count]').textContent = this.text('page', { page: this.state.page, pages: pageCount });
        this.querySelector('[data-oo-previous]').disabled = this.state.page === 1;
        this.querySelector('[data-oo-next]').disabled = this.state.page === pageCount;
        this.querySelector('[data-oo-pagination]').hidden = matches.length <= this.pageSize;
        const searchInput = this.querySelector('[data-oo-search]');
        if (document.activeElement !== searchInput) searchInput.value = this.state.query;
        this.querySelector('[data-oo-sort]').value = this.state.sort;
        this.updateFacets();
        this.updateChips();
      }
      updateFacets() {
        for (const facet of ['series', 'type', 'character']) {
          const pool = this.products.filter(product => this.matches(product, facet));
          for (const option of this.options[facet]) {
            const count = pool.filter(product => product[facet].includes(option.value)).length;
            option.input.checked = this.state[facet].has(option.value);
            option.input.disabled = count === 0 && !option.input.checked;
            option.count.textContent = String(count);
          }
        }
        const typePool = this.products.filter(product => this.matches(product, 'type'));
        for (const parent of this.parentOptions) {
          const chosen = [...parent.types].filter(type => this.state.type.has(type)).length;
          parent.input.checked = chosen === parent.types.size;
          if (chosen > 0) parent.group.open = true;
          parent.input.indeterminate = chosen > 0 && chosen < parent.types.size;
          const count = typePool.filter(product => product.type.some(type => parent.types.has(type))).length;
          parent.input.disabled = count === 0 && chosen === 0;
          parent.count.textContent = String(count);
        }
      }
      updateChips() {
        const fragment = document.createDocumentFragment();
        const entries = ['series', 'type', 'character'].flatMap(facet => [...this.state[facet]].map(value => ({ facet, value })));
        if (this.state.query) entries.push({ facet: 'query', value: this.state.query });
        entries.forEach(({ facet, value }) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'oo-catalogue__chip';
          button.dataset.removeFacet = facet;
          button.dataset.removeValue = value;
          button.setAttribute('aria-label', this.text('remove', { value }));
          const name = document.createElement('span');
          name.textContent = value;
          const close = document.createElement('span');
          close.textContent = '×';
          close.setAttribute('aria-hidden', 'true');
          button.append(name, close);
          item.append(button);
          fragment.append(item);
        });
        const chips = this.querySelector('[data-oo-chips]');
        chips.replaceChildren(fragment);
        chips.hidden = entries.length === 0;
        this.querySelector('[data-oo-clear-selection]').hidden = entries.length === 0;
        this.querySelector('[data-oo-filter-count]').textContent = entries.length ? `(${entries.length})` : '';
        this.querySelectorAll('[data-oo-clear]').forEach(button => { button.disabled = entries.length === 0; });
      }
      commit(resetPage = true) {
        if (resetPage) this.state.page = 1;
        this.render();
        this.writeState();
      }
      onChange(event) {
        const target = event.target;
        if (target.matches('[data-facet]')) {
          const values = this.state[target.dataset.facet];
          if (target.checked) values.add(target.value);
          else values.delete(target.value);
          this.commit();
        } else if (target.matches('[data-type-parent]')) {
          const parent = this.parentOptions.find(option => option.input === target);
          parent.types.forEach(type => { if (target.checked) this.state.type.add(type); else this.state.type.delete(type); });
          this.commit();
        } else if (target.matches('[data-oo-sort]')) { this.state.sort = target.value; this.commit(); }
      }
      onInput(event) {
        if (event.target.matches('[data-oo-search]')) {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.applySearch(), 250);
        } else if (event.target.matches('[data-oo-character-search]')) {
          const query = event.target.value.trim().toLocaleLowerCase();
          let count = 0;
          this.options.character.forEach(option => { option.label.hidden = !option.value.toLocaleLowerCase().includes(query); if (!option.label.hidden) count += 1; });
          this.querySelectorAll('[data-letter]').forEach(heading => {
            let node = heading.nextElementSibling;
            let visible = false;
            while (node && !node.hasAttribute('data-letter')) { if (!node.hidden) visible = true; node = node.nextElementSibling; }
            heading.hidden = !visible;
          });
          this.querySelector('[data-oo-no-characters]').hidden = count > 0;
        }
      }
      applySearch() {
        if (!this.ready) return;
        clearTimeout(this.searchTimer);
        const query = this.querySelector('[data-oo-search]').value.trim();
        if (query !== this.state.query) { this.state.query = query; this.commit(); }
      }
      onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-oo-open-filters]')) {
          this.querySelector('[data-oo-mobile-facets]').append(this.querySelector('[data-oo-facets]'));
          this.querySelector('[data-oo-filter-dialog]').showModal();
        } else if (button.matches('[data-oo-close-filters]')) this.querySelector('[data-oo-filter-dialog]').close();
        else if (button.matches('[data-oo-retry]')) this.load();
        else if (button.matches('[data-oo-clear], [data-oo-clear-selection]')) {
          ['series', 'type', 'character'].forEach(facet => this.state[facet].clear());
          this.state.query = '';
          this.commit();
        } else if (button.matches('[data-remove-facet]')) {
          if (button.dataset.removeFacet === 'query') this.state.query = '';
          else this.state[button.dataset.removeFacet].delete(button.dataset.removeValue);
          this.commit();
        } else if (button.matches('[data-oo-previous], [data-oo-next]')) {
          this.state.page += button.hasAttribute('data-oo-previous') ? -1 : 1;
          this.commit(false);
          const resultsHeading = this.querySelector('[data-oo-result-count]');
          resultsHeading.focus({ preventScroll: true });
          resultsHeading.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      }
      restoreFacets() {
        this.querySelector('[data-oo-desktop-facets]').append(this.querySelector('[data-oo-facets]'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oishii-shopfront"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oishii-shopfront')) {
    customElements.define('oishii-shopfront', class extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        if (!this.initialized) {
          this.initialized = true;
          this.queue = [];
          this.running = 0;
          this.jobs = new Map();
          this.expandedAll = false;
          this.expandedShelves = new Set();
          this.observedShelves = new WeakSet();
          this.onClick = event => this.handleClick(event);
          this.onKeydown = event => this.handleKeydown(event);
          this.onScroll = event => {
            if (!event.target.matches?.('[data-shelf-track]') || this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.shelves.forEach(shelf => this.updateArrows(shelf));
              this.scrollFrame = 0;
            });
          };
        }
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('scroll', this.onScroll, true);
        this.observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.observer.unobserve(entry.target);
              this.observedShelves.delete(entry.target);
              this.loadShelf(entry.target).catch(() => {});
            }
          }
        }, { rootMargin: '500px 0px' }) : null;
        this.mutationObserver = new MutationObserver(() => {
          if (this.refreshFrame) return;
          this.refreshFrame = requestAnimationFrame(() => {
            this.refreshFrame = 0;
            this.refreshShelves();
          });
        });
        this.mutationObserver.observe(this, { childList: true, subtree: true });
        this.resizeObserver = new ResizeObserver(() => this.shelves.forEach(shelf => this.updateArrows(shelf)));
        this.refreshShelves();
        this.resizeObserver.observe(this);
      }
      disconnectedCallback() {
        this.connected = false;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('scroll', this.onScroll, true);
        this.observer?.disconnect();
        this.mutationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.observedShelves = new WeakSet();
        cancelAnimationFrame(this.refreshFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.refreshFrame = 0;
        this.scrollFrame = 0;
      }
      refreshShelves() {
        this.shelves = [...this.querySelectorAll('[data-oishii-shelf]')];
        this.globalButton = this.querySelector('[data-expand-catalogue]');
        this.globalStatus = this.querySelector('[data-catalogue-status]');
        if (!this.globalButton) return;
        this.globalButton.hidden = !this.shelves.length;
        this.globalButton.setAttribute('aria-expanded', String(this.expandedAll));
        const label = this.expandedAll ? this.dataset.collapseCatalogueText : this.dataset.showCatalogueText;
        if (this.globalButton.textContent !== label) this.globalButton.textContent = label;
        for (const shelf of this.shelves) {
          const track = shelf.querySelector('[data-shelf-track]');
          if (!track) continue;
          const expand = shelf.querySelector('[data-expand-shelf]');
          if (expand) expand.hidden = false;
          shelf.dataset.loaded = String(track.querySelectorAll(':scope > [data-shelf-product]').length >= Number(shelf.dataset.total));
          this.setExpanded(shelf, this.expandedAll || this.expandedShelves.has(shelf.id));
          if (shelf.dataset.loaded === 'true' || shelf.dataset.error === 'true' || this.jobs.has(shelf)) continue;
          if (this.expandedAll) {
            this.loadShelf(shelf).catch(() => {});
          } else if (!this.observedShelves.has(shelf)) {
            this.observedShelves.add(shelf);
            this.observer?.observe(shelf);
          }
        }
      }
      handleClick(event) {
        const button = event.target.closest?.('[data-expand-catalogue], [data-expand-shelf], [data-scroll], [data-retry-shelf]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        this.refreshShelves();
        if (button.hasAttribute('data-expand-catalogue')) {
          this.toggleCatalogue();
          return;
        }
        const shelf = button.closest('[data-oishii-shelf]');
        if (!shelf) return;
        if (button.hasAttribute('data-expand-shelf')) {
          this.expandedAll = false;
          this.setExpanded(shelf, !shelf.classList.contains('oo-shelf--expanded'));
        } else if (button.hasAttribute('data-scroll')) {
          const track = shelf.querySelector('[data-shelf-track]');
          track.scrollBy({ left: Number(button.dataset.scroll) * track.clientWidth * .87, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
        this.loadShelf(shelf).catch(() => {});
      }
      handleKeydown(event) {
        const track = event.target;
        if (!track.matches?.('[data-shelf-track]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        track.scrollBy({ left: (event.key === 'ArrowLeft' ? -1 : 1) * track.clientWidth * .87, behavior: 'instant' });
        this.loadShelf(track.closest('[data-oishii-shelf]')).catch(() => {});
      }
      updateArrows(shelf) {
        const track = shelf.querySelector('[data-shelf-track]');
        const previous = shelf.querySelector('[data-scroll="-1"]');
        const next = shelf.querySelector('[data-scroll="1"]');
        const overflow = track.scrollWidth > track.clientWidth + 3;
        previous.disabled = !overflow || track.scrollLeft <= 2;
        next.disabled = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        shelf.querySelector('.oo-shelf__arrows').hidden = !overflow;
        shelf.querySelector('.oo-shelf__hint').hidden = !overflow;
      }
      setExpanded(shelf, expanded) {
        if (expanded) this.expandedShelves.add(shelf.id);
        else this.expandedShelves.delete(shelf.id);
        shelf.classList.toggle('oo-shelf--expanded', expanded);
        const button = shelf.querySelector('[data-expand-shelf]');
        if (button) {
          button.setAttribute('aria-expanded', String(expanded));
          const label = expanded ? shelf.dataset.collapseText : shelf.dataset.showText;
          if (button.textContent !== label) button.textContent = label;
        }
        this.updateArrows(shelf);
      }
      async toggleCatalogue() {
        this.expandedAll = !this.expandedAll;
        this.globalButton.setAttribute('aria-expanded', String(this.expandedAll));
        this.globalButton.textContent = this.expandedAll ? this.dataset.collapseCatalogueText : this.dataset.showCatalogueText;
        this.shelves.forEach(shelf => this.setExpanded(shelf, this.expandedAll));
        if (!this.expandedAll) { this.globalStatus.textContent = ''; return; }
        this.globalStatus.textContent = this.dataset.loadingText;
        const results = await Promise.allSettled(this.shelves.map(shelf => this.loadShelf(shelf)));
        if (!this.expandedAll) return;
        this.globalStatus.textContent = results.some(result => result.status === 'rejected') ? this.dataset.errorText : this.dataset.loadedText;
      }
      loadShelf(shelf) {
        if (shelf.dataset.loaded === 'true') return Promise.resolve();
        if (this.jobs.has(shelf)) return this.jobs.get(shelf);
        shelf.dataset.error = 'false';
        shelf.querySelector('[data-retry-shelf]').hidden = true;
        shelf.querySelector('[data-shelf-status]').textContent = this.dataset.loadingText;
        shelf.querySelector('[data-shelf-track]').setAttribute('aria-busy', 'true');
        const job = new Promise((resolve, reject) => this.queue.push({ shelf, resolve, reject }));
        this.jobs.set(shelf, job);
        this.drain();
        return job;
      }
      drain() {
        while (this.running < 3 && this.queue.length) {
          const task = this.queue.shift();
          this.running += 1;
          this.fetchShelf(task.shelf).then(task.resolve, task.reject).finally(() => {
            this.jobs.delete(task.shelf);
            this.running -= 1;
            this.drain();
          });
        }
      }
      async fetchShelf(shelf) {
        let track = shelf.querySelector('[data-shelf-track]');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const url = new URL(shelf.dataset.collectionUrl, window.location.origin);
          url.searchParams.set('section_id', 'oishii-shelf-feed');
          const currentParams = new URLSearchParams(window.location.search);
          for (const parameter of ['preview_theme_id', '_fd', 'pb']) {
            if (currentParams.has(parameter)) url.searchParams.set(parameter, currentParams.get(parameter));
          }
          if (this.dataset.previewThemeId) url.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Shelf request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = documentFragment.querySelector('[data-oishii-shelf-feed]');
          if (!feed) throw new Error('Shelf response was incomplete');
          const incoming = [...feed.children].filter(child => child.matches('li[data-shelf-product]'));
          if (incoming.length < Number(shelf.dataset.total)) throw new Error('Shelf did not include every product');
          if (!this.contains(shelf)) return;
          track = shelf.querySelector('[data-shelf-track]');
          const existing = new Set([...track.children].map(child => child.dataset.shelfProduct));
          const additions = document.createDocumentFragment();
          for (const item of incoming) {
            if (!existing.has(item.dataset.shelfProduct)) {
              item.classList.add('oo-shelf__item');
              const card = document.importNode(item, true);
              const image = card.querySelector('.oo-card__image');
              if (image && shelf.dataset.imageSizes) image.sizes = shelf.dataset.imageSizes;
              additions.append(card);
              existing.add(item.dataset.shelfProduct);
            }
          }
          track.append(additions);
          shelf.dataset.loaded = 'true';
          shelf.querySelector('[data-shelf-status]').textContent = '';
          this.updateArrows(shelf);
        } catch (error) {
          shelf.dataset.error = 'true';
          shelf.querySelector('[data-shelf-status]').textContent = this.dataset.errorText;
          shelf.querySelector('[data-retry-shelf]').hidden = false;
          throw error;
        } finally {
          clearTimeout(timeout);
          track.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oishii-tamago-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oishii-tamago-hero')) {
    customElements.define('oishii-tamago-hero', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onFocus = () => this.querySelector('slideshow-component')?.pause?.();
        this.onMotionChange = () => {
          if (this.motion.matches) this.querySelector('slideshow-component')?.pause?.();
        };
        this.addEventListener('focusin', this.onFocus);
        this.motion.addEventListener('change', this.onMotionChange);
        customElements.whenDefined('slideshow-component').then(() => {
          if (!this.isConnected) return;
          const slideshow = this.querySelector('slideshow-component');
          if (!slideshow) return;
          this.onMotionChange();
          this.syncLiveRegion = () => slideshow.setAttribute('aria-live', slideshow.paused || !slideshow.autoplay ? 'polite' : 'off');
          this.syncLiveRegion();
          this.stateObserver = new MutationObserver(this.syncLiveRegion);
          this.stateObserver.observe(slideshow, { attributes: true, attributeFilter: ['paused'] });
        });
      }
      disconnectedCallback() {
        this.removeEventListener('focusin', this.onFocus);
        this.motion?.removeEventListener('change', this.onMotionChange);
        this.stateObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
